import { render, staticRenderFns } from "./JobSummary.vue?vue&type=template&id=065a53ca&scoped=true"
import script from "./JobSummary.vue?vue&type=script&lang=js"
export * from "./JobSummary.vue?vue&type=script&lang=js"
import style0 from "./JobSummary.vue?vue&type=style&index=0&id=065a53ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065a53ca",
  null
  
)

export default component.exports